import { createContext } from 'react';

export interface Features {
  [key: string]: boolean;
}

export interface FeaturesContextType {
  features: Features;
  toggleFeature: (key: string) => void;
}

const FeaturesContext = createContext<FeaturesContextType>({
  features: {},
  toggleFeature: () => undefined,
});

export default FeaturesContext;
